import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                {
                    label: t('task.task', 2),
                    icon: 'pi pi-fw pi-list',
                    to: 'tasks'
                }
            ]
        }
    ]
}
